import Img1 from "./Icon/blog1Img1.jpeg";
import Img2 from "./Icon/blogImg2.jpeg";
import Img3 from "./Icon/blog3Img.jpeg";
import Img4 from "./Icon/blog41.jpeg";
import Img5 from "./Icon/blog51.jpeg";
import Img6 from "./Icon/blog61.jpeg";
import Img7 from "./Icon/blog1Img1.jpeg";
import Img8 from "./Icon/img8.jpeg";
const cardData = [
  {
    card_id: 1,
    title: "Police Departments Register Complaints via WhatsApp - Simple Guide",
    tags: ["Remote Work", "Webinar"],
    card_image: Img1,
    category: "categoryA",
  },
  {
    card_id: 2,
    title: "Transform Car Dealerships with WhatsApp API",
    tags: ["Agile Practices", "Teamwork"],
    card_image: Img2,
    category: "categoryA",
  },
  {
    card_id: 3,
    title: "WhatsApp Business API vs. Google & Facebook Ads for Data Insights",
    tags: ["Productivity", "Webinar"],
    card_image: Img3,
    category: "categoryA",
  },
  {
    card_id: 4,
    title: "Hidden struggles in higher education can be solved by WhatsApp API",
    tags: ["Leadership", "Webinar"],
    card_image: Img4,
    category: "categoryB",
  },
  {
    card_id: 5,
    title: "WhatsApp Business API: Hassle-Free Hospital Appointments & Services",
    tags: ["Quick Tips", "Agile Practices"],
    card_image: Img5,
    category: "categoryB",
  },
  {
    card_id: 6,
    title: "Fixing Key Education Gaps in India with WhatsApp API",
    tags: ["Communication", "Webinar"],
    card_image: Img6,
    category: "categoryB",
  },
  {
    card_id: 7,
    title: "Public Scheme Awareness Campaigns with WhatsApp",
    tags: ["Agile", "Webinar"],
    card_image: Img7,
    category: "categoryC",
  },
  {
    card_id: 8,
    title: "Simplify Logistics with WhatsApp: Smarter, Faster, Better",
    tags: ["Collaboration", "Webinar"],
    card_image: Img8,
    category: "categoryC",
  },
  {
    card_id: 9,
    title: "Card 9",
    tags: ["Collaboration", "Webinar"],
    card_image: Img1,
    category: "categoryC",
  },

  {
    card_id: 10,
    title: "Card 10",
    tags: ["Leadership", "Webinar"],
    card_image: Img2,
    category: "categoryD",
  },
  {
    card_id: 11,
    title: "Card 11",
    tags: ["Quick Tips", "Agile Practices"],
    card_image: Img3,
    category: "categoryD",
  },
  {
    card_id: 12,
    title: "Card 12",
    tags: ["Communication", "Webinar"],
    card_image: Img4,
    category: "categoryD",
  },

];

export default cardData;
